const config = {
  projectLaunchDur: 600,
  afterLaunchDur: 2500,
}

export default config
